/**
 * @flow
 * @relayHash 6a0e1d26517cde2c383c365d8a0f1f66
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SbRespNullSearchResultsTilesLoaderQueryResponse = {|
  +viewer: ?{| |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "showModules",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SbRespNullSearchResultsTilesLoaderQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CategoryTiles_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": "app-buyer-finding/197.0.0-2018-12-19T18:19:19.050Z/SbRespNullSearchResultsTilesLoaderQuery",
  "kind": "Batch",
  "metadata": {},
  "name": "SbRespNullSearchResultsTilesLoaderQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "showModules",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SbRespNullSearchResultsTilesLoaderQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showModules",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "trendingFurniture",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "categoryLevels",
                    "value": 2,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "numItems",
                    "value": 2,
                    "type": "Int!"
                  },
                  {
                    "kind": "Literal",
                    "name": "parentCategory",
                    "value": "FURNITURE",
                    "type": "TrendingCategoryKeyType"
                  },
                  {
                    "kind": "Literal",
                    "name": "trendType",
                    "value": "CATEGORY",
                    "type": "TrendingTypes!"
                  }
                ],
                "concreteType": "TrendingModules",
                "name": "trending",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "image",
                    "storageKey": null
                  }
                ],
                "storageKey": "trending{\"categoryLevels\":2,\"numItems\":2,\"parentCategory\":\"FURNITURE\",\"trendType\":\"CATEGORY\"}"
              },
              {
                "kind": "LinkedField",
                "alias": "trendingArt",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "categoryLevels",
                    "value": 2,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "numItems",
                    "value": 2,
                    "type": "Int!"
                  },
                  {
                    "kind": "Literal",
                    "name": "parentCategory",
                    "value": "ART",
                    "type": "TrendingCategoryKeyType"
                  },
                  {
                    "kind": "Literal",
                    "name": "trendType",
                    "value": "CATEGORY",
                    "type": "TrendingTypes!"
                  }
                ],
                "concreteType": "TrendingModules",
                "name": "trending",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "image",
                    "storageKey": null
                  }
                ],
                "storageKey": "trending{\"categoryLevels\":2,\"numItems\":2,\"parentCategory\":\"ART\",\"trendType\":\"CATEGORY\"}"
              },
              {
                "kind": "LinkedField",
                "alias": "trendingFashion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "categoryLevels",
                    "value": 2,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "numItems",
                    "value": 2,
                    "type": "Int!"
                  },
                  {
                    "kind": "Literal",
                    "name": "parentCategory",
                    "value": "FASHION",
                    "type": "TrendingCategoryKeyType"
                  },
                  {
                    "kind": "Literal",
                    "name": "trendType",
                    "value": "CATEGORY",
                    "type": "TrendingTypes!"
                  }
                ],
                "concreteType": "TrendingModules",
                "name": "trending",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "image",
                    "storageKey": null
                  }
                ],
                "storageKey": "trending{\"categoryLevels\":2,\"numItems\":2,\"parentCategory\":\"FASHION\",\"trendType\":\"CATEGORY\"}"
              },
              {
                "kind": "LinkedField",
                "alias": "trendingJewelry",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "categoryLevels",
                    "value": 2,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "numItems",
                    "value": 2,
                    "type": "Int!"
                  },
                  {
                    "kind": "Literal",
                    "name": "parentCategory",
                    "value": "JEWELRY",
                    "type": "TrendingCategoryKeyType"
                  },
                  {
                    "kind": "Literal",
                    "name": "trendType",
                    "value": "CATEGORY",
                    "type": "TrendingTypes!"
                  }
                ],
                "concreteType": "TrendingModules",
                "name": "trending",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "image",
                    "storageKey": null
                  }
                ],
                "storageKey": "trending{\"categoryLevels\":2,\"numItems\":2,\"parentCategory\":\"JEWELRY\",\"trendType\":\"CATEGORY\"}"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
